import { forwardRef, type Ref } from 'react';

import { Link, type LinkProps } from 'react-resource-router';

import { RouterLinkComponentProps } from '@atlaskit/app-provider';

type ReactResourceRouterLinkConfig = Pick<LinkProps, 'to' | 'href' | 'replace'>;

export const AppProviderLink = forwardRef(
  (
    {
      href,
      children,
      ...rest
    }: RouterLinkComponentProps<ReactResourceRouterLinkConfig>,
    ref: Ref<HTMLAnchorElement>
  ) => {
    // A basic link by passing a string as the component's `href` prop.
    if (typeof href === 'string') {
      return (
        <Link ref={ref} href={href} {...rest}>
          {children}
        </Link>
      );
    }

    // Advanced link configuration by passing an object as the
    // component's `href` prop
    return (
      <Link
        ref={ref}
        href={href?.href}
        to={href?.to}
        replace={href?.replace}
        {...rest}
      >
        {children}
      </Link>
    );
  }
);
